<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter1">1. Gambling in America</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">2. Gambling Economics</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">3. Gambling: 1900s–1920s</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">4. Louis Cella: Horse Track Kingpin</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">5. Barney Schreiber: Turf Man</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">6. Henry “Kid” Becker: Bookmaker</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">7. John Walters: Betting Commissioner</span></p>
<p class="TOC"><span href="#/Chapter8" title="Link target outside of Sample">8. Thomas “Chicago” O’Brien: Track Bettor</span></p>
<p class="TOC"><span href="#/Chapter9" title="Link target outside of Sample">9. Senorita Concepion de Hara: Faro Gambler</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">10. Honest John Kelly: Casino Owner</span></p>
<p class="TOC"><span href="#/Chapter11" title="Link target outside of Sample">11. Mont Tennes: Casino, Bookie, Wire Service</span></p>
<p class="TOC"><span href="#/Chapter12" title="Link target outside of Sample">12. Moses “Mo” Annenberg: Publisher, Wire Service</span></p>
<p class="TOC"><span href="#/Chapter13" title="Link target outside of Sample">13. Big Jim O’Leary: South Side Gambler</span></p>
<p class="TOC"><span href="#/Chapter14" title="Link target outside of Sample">14. Broadway Jack Doyle: Handicapper</span></p>
<p class="TOC"><span href="#/Chapter15" title="Link target outside of Sample">15. Tom Kerney: Bookmaker, Oddsmaker</span></p>
<p class="TOC"><span href="#/Chapter16" title="Link target outside of Sample">16. Tom Shaw: Bookmaker, Oddsmaker</span></p>
<p class="TOC"><span href="#/Chapter17" title="Link target outside of Sample">17. Tim Mara: Bookmaker, Sports Team Owner</span></p>
<p class="TOC"><span href="#/Chapter18" title="Link target outside of Sample">18. Charles Bidwill Sr.: Track Owner, Sports Team Owner</span></p>
<p class="TOC"><span href="#/Chapter19" title="Link target outside of Sample">19. Betting on the East Side: 1930s–1950</span></p>
<p class="TOC"><span href="#/Chapter20" title="Link target outside of Sample">20. Open Gambling in New Orleans: 1930s–1950</span></p>
<p class="TOC"><span href="#/Chapter21" title="Link target outside of Sample">21. Organized Crime</span></p>
<p class="TOC"><span href="#/Chapter22" title="Link target outside of Sample">22. Kefauver Hearings: Criminal Impact on Gambling</span></p>
<p class="TOC"><span href="#/Chapter23" title="Link target outside of Sample">23. James J. Carroll: Oddsmaker, Kefauver Hearings</span></p>
<p class="TOC"><span href="#/Chapter24" title="Link target outside of Sample">24. Gambling Recovery</span></p>
<p class="TOC"><span href="#/Chapter25" title="Link target outside of Sample">25. Today’s Bookmakers</span></p>
<p class="TOC"><span href="#/Chapter26" title="Link target outside of Sample">26. Current Operations</span></p>
<p class="TOC"><span href="#/Chapter27" title="Link target outside of Sample">27. Future Direction</span></p>
<p class="TOC"><span href="#/Chapter28" title="Link target outside of Sample">28. Reflections</span></p>
<p class="TOC1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?4db89c6c